/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActualizarParametroProgramaModelDto } from '../../models/actualizar-parametro-programa-model-dto';

export interface ProgramaParametrosControllerUpdateProgramaParametro$Params {
  uuidPrograma: string;
  
    /**
     * Lista de parametrizaciones a actualizar
     */
    body: Array<ActualizarParametroProgramaModelDto>
}

export function programaParametrosControllerUpdateProgramaParametro(http: HttpClient, rootUrl: string, params: ProgramaParametrosControllerUpdateProgramaParametro$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, programaParametrosControllerUpdateProgramaParametro.PATH, 'put');
  if (params) {
    rb.path('uuidPrograma', params.uuidPrograma, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

programaParametrosControllerUpdateProgramaParametro.PATH = '/api/programa-parametros/{uuidPrograma}';
